import { Section, TableOfContent } from '../../../typings/interfaces';
import { FRENCH } from '../../../assets/images';
// French
const FRSection: Section[] = [
  {
    name: '1: Référence et aperçu',
    subSections: [
      {
        name: 'Préambule',
        page: 3,
      },
      {
        name: 'Objectif et applications du guide pratique',
        page: 4,
      },
      {
        name: 'Définitions importantes',
        page: 5,
      },
      {
        name: 'Hiérarchie des contrôles',
        page: 6,
      },
    ],
  },
  {
    name: '2: LIFESavers',
    subSections: [
      {
        name: 'Véhicules motorisés – Sécurité routière',
        page: 9,
      },
      {
        name: 'Travaux en hauteur',
        page: 12,
      },
      {
        name: 'Équipement mobile',
        page: 18,
      },
      {
        name: `Isolation des sources d'énergie par condamnation/étiquetage`,
        page: 22,
      },
      {
        name: 'Travaux électriques',
        page: 25,
      },
      {
        name: 'Espace confiné',
        page: 29,
      },
      {
        name: 'Stockage de produits en vrac',
        page: 32,
      },
      {
        name: 'Sécurité des voies ferrées',
        page: 37,
      },
      {
        name: `Travaux d'excavation et de tranchées`,
        page: 41,
      },
      {
        name: 'Levage et arrimage',
        page: 45,
      },
      {
        name: 'Matières dangereuses',
        page: 49,
      },
      {
        name: 'Travaux par points chauds',
        page: 52,
      },
    ],
  },
  {
    name: '3: Ressources et outils supplémentaires',
    subSections: [
      {
        name: `Travaux au-dessus et à proximité de l'eau`,
        page: 56,
      },
      {
        name: `Chutes d'objets`,
        page: 59,
      },
      {
        name: 'Tests atmosphériques/ gazeux',
        page: 61,
      },
      {
        name: 'Communication des dangers chimiques',
        page: 65,
      },
    ],
  },
  {
    name: '4: Pratiques de gestion de la sécurité de Cargill ',
    subSections: [
      {
        name: 'Terminologie essentielle',
        page: 70,
      },
      {
        name: 'Événements entraînant des blessures graves ou des décès',
        page: 72,
      },
      {
        name: 'Catégorisation des risques de blessures graves ou de décès',
        page: 73,
      },
      {
        name: 'Tableau de détermination automatique des blessures graves/décès',
        page: 74,
      },
      {
        name: 'Performances Humaines et Organisationnelles (HOP)',
        page: 76,
      },
    ],
  },
];

const FRTableOfContent: TableOfContent = {
  language: 'fr',
  sections: FRSection,
  label: 'Table des matières',
  pdfLink:
    'https://en-pdfs-life-on-focus.dev.cglcloud.in/Cargill Field Safety Guide French (fr_FR)_DIGITAL_CROPPED.pdf',
  hopPocket: 'Guide de poche sur le programme HOP',
  hopPocketLink:
    'https://en-pdfs-life-on-focus.dev.cglcloud.in/HOP pocket guide content 2021-09-08_French (France).pdf',
  source: FRENCH,
};

export default FRTableOfContent;
